import {Circle, Sprite, Text} from 'pixi.js';
import Button from '../../gamma-engine/core/view/ui/Button';
import { IntroScreenEvent } from '../../gamma-engine/common/view/event/IntroScreenEvent';
import SoundManager from '../../gamma-engine/core/sound/SoundManager';
import SoundList from '../../gamma-engine/common/sound/SoundList';
import LayoutBuilder from '../../gamma-engine/core/utils/LayoutBuilder';
import AssetsManager from '../../gamma-engine/core/assets/AssetsManager';
import LayoutElement from '../../gamma-engine/core/view/model/LayoutElement';
import AdjustableLayoutContainer from '../../gamma-engine/core/view/AdjustableLayoutContainer';
import IntroScreenBackground from './IntroScreenBackground';
import ButtonSpin from '../../gamma-engine/common/view/ButtonSpin';
import {UpdateLayoutDescription} from '../../gamma-engine/core/view/UpdateLayoutDescription';
// import {ScreenOrientation} from "../../gamma-engine/core/view/ScreenOrientation";
// import {getFromLocalStorage} from "../model/LocalStorageUtils";
// import {SettingsType} from "../model/SettingsType";
import ButtonSpinAnimation from '../../gamma-engine/common/view/ButtonSpinAnimation';
import { Tweener } from '../../gamma-engine/core/tweener/engineTween';
import Logo from '../../gamma-engine/common/view/Logo';
import Character from './Character';

export default class IntroScreen extends AdjustableLayoutContainer {

    // VISUALS
    private logo: Sprite;
    private btnGetStarted: ButtonSpin;
    private background: IntroScreenBackground;
    private tfIntroText: Text;
    private keydownListner = (e: KeyboardEvent) => this.onGetStarted(e);

    constructor() {
        super(AssetsManager.layouts.get('intro-screen'));
        LayoutBuilder.create(this.layout, this, (le: LayoutElement) => {
            return this.customClassElementCreate(le);
        });
        /* eslint-disable */
        this.tfIntroText = this['tfIntroText'];
        this.tfIntroText.style.dropShadow = true;
        this.tfIntroText.style.dropShadowColor = '#000000';
        this.tfIntroText.style.dropShadowDistance = 7;
        this.tfIntroText.style.dropShadowAngle = Math.PI/4;

        this.btnGetStarted.on('pointerup', this.onGetStartedClicked, this);
        document.body.addEventListener('keydown', this.keydownListner);

        this.on('added', this.onAdded,this)
        this.on('removed', this.onRemoved, this);
    }
    public updateLayout(desc: UpdateLayoutDescription) {
        super.updateLayout(desc);

        // const introTextMobilePos:number = 540
        // const introTextDesktopPos:number = 719
        // this.tfIntroText.pivot.set(this.tfIntroText.width/2,this.tfIntroText.height/2)
        // this.tfIntroTextMobile.pivot.set(this.tfIntroTextMobile.width/2,this.tfIntroTextMobile.height/2)
        // if(desc.orientation == ScreenOrientation.VERTICAL){
        //     this.tfIntroTextMobile.x = introTextMobilePos
        // }
        // else{
        //     this.tfIntroText.x  = introTextDesktopPos
        // }

    }

    // PRIVATE API
    private onRemoved(): void {
        Tweener.removeTweens(this);
        this.btnGetStarted.removeTweens()
        if (this.keydownListner) {
            document.body.removeEventListener('keydown', this.keydownListner);
        }
    }

    private customClassElementCreate(le: LayoutElement): unknown {
        let instance: unknown = null;

        switch (le.customClass) {
            case 'ButtonGetStarted':
                instance = new ButtonSpin(le);
                const btn = instance as Button;
                btn.hitArea = new Circle(0, 0, 90);

                break;
            case 'IntroScreenBackground':
                instance = new IntroScreenBackground();
                break;
            case 'Logo':
                instance = new Logo(true);
                break;
            case 'Character':
                instance = new Character(false);
                break;
        }

        return instance;
    }
    private onAdded():void{
        this.btnGetStarted.waitAnimation(ButtonSpinAnimation.WAIT)
    }
    
    // USER INTERACTION
    private onGetStartedHandler(): void {
        this.btnGetStarted.enabled = false;
        SoundManager.play(SoundList.UI_BUTTON_CLICK);
        this.emit(IntroScreenEvent.ON_GET_STARTED_CLICKED);
    }
    
    private onGetStartedClicked(): void {
        this.onGetStartedHandler();
    }

    private onGetStarted(event: KeyboardEvent): void {
        if(event.key){
            this.onGetStartedHandler();
        }
    }
}
